interface UpdateAvailableBannerProps {
  onUpdate: () => void;
}

// Fixed bottom-right "a new version is available" widget, surfaced once
// useNewVersionAvailable() detects the deployed build has moved on.
export const UpdateAvailableBanner = ({
  onUpdate,
}: UpdateAvailableBannerProps) => (
  <div className="fixed bottom-4 right-4 z-50 flex max-w-sm items-center gap-3 rounded-lg border border-gray-200 bg-white p-4 shadow-lg dark:border-dark-borderMid dark:bg-dark-background">
    <svg
      className="h-5 w-5 flex-shrink-0 text-indigo-600"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.312 4.687a6.5 6.5 0 1 0 1.688 5.951M17 3v4h-4"
      />
    </svg>
    <p className="flex-1 text-sm text-gray-900 dark:text-white">
      A new version is available.
    </p>
    <button
      type="button"
      onClick={onUpdate}
      className="flex-shrink-0 rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-indigo-700"
    >
      Refresh
    </button>
  </div>
);
